import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../components/ModalComponent';

const CannotChangePlanErrorPage = () => {
  const Navigate = useNavigate();
  const [showIncompletePaymentModal, setShowIncompletePaymentModal] = useState(true);

  const handleIncompletePaymentModal = () => {
    setShowIncompletePaymentModal(!showIncompletePaymentModal);
    Navigate('/my-account/plans');
  };

  return (
    <div>
      <ModalComponent
        title="Cannot change plan"
        body={(
          <div>
            <div>
              You cannot change to this plan because you have more pages than the plan allows.
            </div>
          </div>
        )}
        centered
        animation={false}
        show={showIncompletePaymentModal}
        onConfirm={handleIncompletePaymentModal}
        closeModal={handleIncompletePaymentModal}
        cancelButtonText="Go to account settings"
        hideConfirmButton
      />
    </div>
  );
};

export default CannotChangePlanErrorPage;
